import { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import appConfig from '@nerdwallet/app-config';
import querystring from 'query-string';
import { getLogger } from '@nerdwallet/logging';
import nwApiSDK from '../../lib/nw-api-sdk';

const logger = getLogger('NpsCrmEmail');

export const postNpsQueryStrings = (query, SDK = nwApiSDK) => {
  const npsScore = parseInt(query.nps_score, 10);
  const npsToken = query.update_nps_token;
  const npsPayload = {
    nps_score: npsScore,
    update_nps_token: npsToken,
  };

  logger.info('NPS-CRM-EMAIL postNps request', {
    name: 'postNpsQueryStrings ',
    url: `${appConfig.API.BASE_URLS.IDENTITY}/api/v1/user-comms/nps_result`,
    paylod: npsPayload,
  });

  SDK.ServiceSDK.post(
    `${appConfig.API.BASE_URLS.IDENTITY}/api/v1/user-comms/nps_result`,
    npsPayload
  );
};

export const getNpsQueryStrings = (search) => {
  const query = querystring.parse(search);
  const containsNpsScoreAndToken = query.nps_score && query.update_nps_token;
  if (containsNpsScoreAndToken) {
    return query;
  }
  return null;
};

class NpsCrmEmail extends Component {
  componentDidMount() {
    const processedNpsQueryStrings = getNpsQueryStrings(
      this.props.location.search
    );
    if (processedNpsQueryStrings) {
      postNpsQueryStrings(processedNpsQueryStrings);
    }
    logger.info('NPS-CRM-EMAIL component mounted', {
      name: 'NpsCrmEmail',
      props: this.props,
    });
  }

  render() {
    return null;
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
NpsCrmEmail.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

export default withRouter(NpsCrmEmail);
